export const GET_AUTH_CASES_LIST = 'GET_AUTH_CASES_LIST';
export const SET_AUTH_CASES_LIST = 'SET_AUTH_CASES_LIST';


export const getAuthCasesList = () => {
    return {
        type: GET_AUTH_CASES_LIST
    };
}


export  const setAuthCasesList = (authAllCasesList: any) => {
    return {
        type: SET_AUTH_CASES_LIST, payload: {
            authAllCasesList
        }
    };
}
